export class Message {
  message: String;
  variant: String;

  constructor (message: String, variant: String) {
    this.message = message
    this.variant = variant
  }
}
